import React, { FC, useEffect, useState } from 'react';
import './presenter-mobile-side-strips.scss';
import { PresenterTabsOnMobile } from '../../../constans/presenter-enums';
import { useStore } from '../../../store/store-provider';
import { observer } from 'mobx-react';
import { PRESENTER_MOBILE_BREAK_POINT } from '../../../constans/presenter-constansts';
import PresenterMobileSideStrip from './presenter-mobile-side-strip/presenter-mobile-side-strip';

interface IProps {
  currentTab: PresenterTabsOnMobile;
}

const PresenterMobileSideStrips: FC<IProps> = ({ currentTab }): JSX.Element | null => {
  const [ imageHeight, setImageHeight ] = useState<number>(0);
  const { slideManagementStore, podiumInfoStore } = useStore();
  const { isResolutionBreakPointActive, windowResolution: { height }} = podiumInfoStore;
  const { getSlideManagementEntity } = slideManagementStore;
  const { getActivePointer } = getSlideManagementEntity();
  const currentSlideImgSrc = getActivePointer()?.getSmallThumbnail();
  const isMobile = isResolutionBreakPointActive(PRESENTER_MOBILE_BREAK_POINT);

  useEffect(() => {
    if(!isMobile) return;
    const parentImageHeight = document.querySelector('.presenter-slide-carousel__current-slide');
    if(parentImageHeight) {
      setImageHeight(parentImageHeight.clientHeight);
    }

  }, [height, isMobile, currentTab]);

  const commonOptions = { imageHeight, currentSlideImgSrc };

  switch (currentTab) {
    case PresenterTabsOnMobile.CLICKER:
      return (
        <PresenterMobileSideStrip
          hasLtSide
          options={{
            ...commonOptions,
            ltSideCls: 'mobile-side-strip_clicker-tab'
          }}
        />
      );
    case PresenterTabsOnMobile.NOTES:
      return (
        <PresenterMobileSideStrip
          hasLtSide
          hasRtSide
          hasMiddleBody
          options={{
            ...commonOptions,
            ltSideCls: 'mobile-side-strip_notes-tab',
            rtSideCls: 'mobile-side-strip_notes-common'
          }}
        />
      );
    case PresenterTabsOnMobile.QUESTIONS:
      return (
        <PresenterMobileSideStrip
          hasRtSide
          options={{
            rtSideCls: 'mobile-side-strip_questions-tab-left'
          }}
        />
      );
    default:
      return null;
  }
};

export default observer(PresenterMobileSideStrips);
